import * as angular from "angular";
import {AgreementsRequests} from "./agreements-requests-service.service";
import {SitesAlertsService} from "../../sites/services/sites-alerts.service";

export class AgreementService {

  constructor(private agreementsRequests: AgreementsRequests, private sitesAlertsService: SitesAlertsService) {
  }

  updateVersion(agreementId:string, version) {
    return new Promise((resolve, reject) => {
      this.agreementsRequests.updateVersion(agreementId, version)
        .then((latestVersion) => {
          this.sitesAlertsService.updateAgreementSuccess();
          resolve(latestVersion);
        })
        .catch((error) => {
          this.sitesAlertsService.updateAgreementError();
          reject(error);
        })
    });
  }

}

angular
  .module('bringoz.admin.agreements')
  .service('agreementService', AgreementService);
